import httpClient from '../utils/http'
import { handleResponseAsync } from '../utils/HelperUtils'
import { normalize } from 'normalizr'
import { contactsSchema } from './../entities/schema'
import _ from 'lodash'

export const contactsService = {
    getContacts,
    updateContact,
    addContact,
    removeContactById,
}

function convertViewModelList(data) {
    const contactListSchema = [contactsSchema]
    const normalizedData = normalize(data, contactListSchema)
    return normalizedData.entities
}

function convertViewModel(data) {
    const normalizedData = normalize(data, contactsSchema)
    return normalizedData.entities
}

function convertById(data) {
    return data.id
}

function getContacts() {
    const url = '/api/contact'

    return httpClient
        .get(url)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function updateContact(data) {
    const url = '/api/contact'

    return httpClient
        .put(url, data)
        .then(handleResponseAsync)
        .then(res => convertViewModel(_.first(res.data)))
}

function addContact(data) {
    const url = '/api/contact'

    return httpClient
        .post(url, data)
        .then(handleResponseAsync)
        .then(res => convertViewModel(res.data))
}

function removeContactById(id) {
    const url = `/api/contact/${id}`

    return httpClient
        .delete(url)
        .then(handleResponseAsync)
        .then(res => convertById(res.data))
}
